import { Card, CardHeader, StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { BpM } from '../../shared/brakepoints';
import Translator from '../../components/Translator';
import { LanguageEntries } from '../../shared/language/LanguageEntries';
import FintechOneContact from '../../components/FintechOneSupport';

export type errorType = 'forbidden' | 'notfound' | 'unknown';

type CssClasses = 'cardContent' | 'container' | 'fullPage' ;
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  container: {
    width: '100%',
    [BpM()]: {
      width: '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardContent: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    fontSize: '17px',
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    color: '#666',
  },
  fullPage: {
    height: '100%',
  },
});

interface OwnProps {
  error: errorType;
  forbidden: keyof LanguageEntries;
  notFound: keyof LanguageEntries;
  unknown: keyof LanguageEntries;
}

class ErrorPage extends React.Component<OwnProps & WithStyles<CssClasses>> {
  render() {
    let { classes, error, forbidden, notFound, unknown } = this.props;

    let errorLanguageEntry: keyof LanguageEntries;

    switch (error) {
      case 'forbidden':
        errorLanguageEntry = forbidden;
        break;
      case 'notfound':
        errorLanguageEntry = notFound;
        break;
      default:
        errorLanguageEntry = unknown;
        break;
    }

    return (
      <Translator>
        {translate => {
          return (
            <div className={classes.fullPage}>
              <Card className={classes.container}>
                <CardHeader title={translate('error')} />
                <div className={classes.cardContent}>
                  <p>{translate(errorLanguageEntry)}</p>
                  <FintechOneContact />
                </div>
              </Card>
            </div>
          );
        }}
      </Translator>
    );
  }
}

export default pure(withStyles(styles)(ErrorPage));



// WEBPACK FOOTER //
// ./src/routes/responsePage/ErrorPage.tsx